import { render, staticRenderFns } from "./Projectstatistics.vue?vue&type=template&id=588446b2&scoped=true&"
import script from "./Projectstatistics.vue?vue&type=script&lang=js&"
export * from "./Projectstatistics.vue?vue&type=script&lang=js&"
import style0 from "./Projectstatistics.vue?vue&type=style&index=0&id=588446b2&scoped=true&lang=css&"
import style1 from "./Projectstatistics.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588446b2",
  null
  
)

export default component.exports